import { createFileRoute } from "@tanstack/react-router";

// Layout route for both mission views. Keeping it empty here (the shell lives
// in route.lazy.tsx) keeps the report/seilelinje code out of the entry bundle.
export const Route = createFileRoute("/_sidebar/mission/$missionId")({});
